export default [
  { value: 'Category', name: 'Категорию' },
  { value: 'Element', name: 'Элемент' },
  { value: 'Parameter', name: 'Параметр' },
]
